module.exports = __webpack_public_path__ + "img/dashiji-2014.66589ce7.jpg";